import { ContainerComponent, wrap } from 'AppReact';
import {
  FlexCenterWrapper, CursorPointerWrapper, Mr3, FitRelativeWrapper,
  AbsoluteLeftTopWrapper, CustomBorderWrapper,
  Mt4, FlexCenterJustifyEndWrapper, Width350, CountWrapper
} from 'wrappers';
import { Icon, SecondaryTextSm, PrimaryTextSm, WhiteTextXs } from 'atoms';
import { IconTextButton } from 'molecules';
import AssignedToBoxDropdown from 'containers/assignedToBoxDropdown';
import { MoreFiltersSvg, HomeSvg, TrashBinSvg, TickSvg, UserSvg } from 'components/icons';
import React from 'react';
import internalState from './internalState';
import Controller from './controller';
import BoxDropdown from '../boxDropdown';
import { getTotalFilters } from './utils';

const containerRef = React.createRef();

export const definition = {
  name: 'InspectionsFilters',
  controller: Controller,
  initialProps: ({
    assignedPersons, selectedInspectionStatuses, selectedUnitIds, selectedAssignedToIds, units, admins, residents, techs
  }) => ({
    assignedPersons, selectedInspectionStatuses, selectedUnitIds, selectedAssignedToIds, units, admins, residents, techs
  }),
  props: internalState,
  elements: [
    {
      wrapper: FitRelativeWrapper,
      name: 'Wrapper',
      ref: containerRef,
      elements: [
        {
          wrapper: wrap(FlexCenterWrapper, CursorPointerWrapper),
          name: 'HeaderWrapper',
          isButton: true,
          bindings: ({
            selectedInspectionStatuses, selectedUnitIds, selectedAssignedToIds, isOpen
          }) => ({ selectedInspectionStatuses, selectedUnitIds, selectedAssignedToIds, containerRef, isOpen }),
          elements: [
            {
              component: wrap(Icon, Mr3),
              name: 'Icon',
              displayValue: ({ isOpen,
                selectedUnitIds,
                selectedInspectionStatuses,
                selectedAssignedToIds
              }) => MoreFiltersSvg({
                color: isOpen || getTotalFilters({
                  selectedUnitIds,
                  selectedInspectionStatuses,
                  selectedAssignedToIds,
                }) > 0 ?
                  window?.settings?.primary_color : window?.settings?.secondary_color
              })
            },
            {
              component: wrap(SecondaryTextSm, Mr3),
              renderIf: ({ isOpen,
                selectedUnitIds,
                selectedInspectionStatuses,
                selectedAssignedToIds,
              }) => !isOpen && getTotalFilters({
                selectedUnitIds,
                selectedInspectionStatuses,
                selectedAssignedToIds,
              }) === 0,
              name: 'Text',
              displayValue: ({ }) => 'Filters'
            },
            {
              component: wrap(PrimaryTextSm, Mr3),
              renderIf: ({ isOpen, selectedUnitIds,
                selectedInspectionStatuses,
                selectedAssignedToIds,
              }) => isOpen || getTotalFilters({
                selectedUnitIds,
                selectedInspectionStatuses,
                selectedAssignedToIds,
              }) > 0,
              name: 'Text',
              displayValue: ({ }) => 'Filters'
            },
            {
              component: wrap(WhiteTextXs, CountWrapper),
              renderIf: ({
                isOpen,
                selectedUnitIds,
                selectedInspectionStatuses,
                selectedAssignedToIds
              }) => {

                let total = 0;
                const filters = [selectedInspectionStatuses?.length > 0, selectedUnitIds?.length > 0, selectedAssignedToIds?.length > 0];
                filters.forEach((item) => {
                  if (item) total += 1;
                });
                let shouldDisplay = !isOpen && total > 0
                return shouldDisplay
              },
              name: 'Text',
              displayValue: ({
                selectedUnitIds,
                selectedInspectionStatuses,
                selectedAssignedToIds
              }) => {
                return `${getTotalFilters({
                  selectedUnitIds,
                  selectedInspectionStatuses,
                  selectedAssignedToIds
                })}`
              }
            },
          ]
        },
        {
          wrapper: AbsoluteLeftTopWrapper,
          displayState: ({ }) => ({ top: '30px' }),
          renderIf: ({ isOpen }) => isOpen,
          name: 'DropdownWrapper',
          elements: [
            {
              wrapper: CustomBorderWrapper,
              name: 'BorderWrapper',
              displayState: ({ }) => ({
                borderRadius: '8px',
                border: '1px solid #E3E3E3',
                background: '#FFFFFF',
                padding: '12px'
              }),
              elements: [
                {
                  component: BoxDropdown,
                  name: 'Status',
                  bindings: ({ selectedInspectionStatuses }) => {
                    const entries = [{ id: 'completed', label: 'Completed' }, { id: 'open', label: 'Open' }];
                    return {
                      label: 'Status',
                      icon: TickSvg({ circle: true, width: 15, height: 15 }),
                      selectedIds: selectedInspectionStatuses,
                      entries
                    };
                  }
                },
                {
                  component: wrap(wrap(BoxDropdown, Width350), Mt4),
                  name: 'Unit',
                  bindings: ({ selectedUnitIds, units }) => {
                    const entries = units.map((u) => ({ id: u.id, label: `${u.number} - ${u.property ?? ''}` }));
                    return {
                      label: 'Unit',
                      icon: HomeSvg({ width: 15, height: 15 }),
                      selectedIds: selectedUnitIds ?? [],
                      entries
                    };
                  }
                },
                {
                  component: wrap(wrap(AssignedToBoxDropdown, Width350), Mt4),
                  name: 'AssignedToDropdown',
                  bindings: ({ assignedPersons, selectedAssignedToIds }) => {
                    return {
                      label: 'Assigned to',
                      icon: UserSvg({ width: 15, height: 15, color: window?.settings?.primary_color }),
                      selectedIds: selectedAssignedToIds,
                      assignedPersons,
                    };
                  }
                },
                {
                  component: wrap(wrap(IconTextButton, Mt4), FlexCenterJustifyEndWrapper),
                  name: 'ResetFilters',
                  bindings: ({ }) => ({ icon: TrashBinSvg({}), title: 'Clear filters' })
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};

export default ContainerComponent(definition);
